import React from "react";
import { LuPhone, LuMail, LuMapPin } from "react-icons/lu";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";

const contactDetails = [
  { label: "Phone",        value: "(214) 635-6340",                href: "tel:2146356340",                        sub: "Call or text — we're available during business hours", Icon: LuPhone  },
  { label: "Email",        value: "khojadistributions@gmail.com",  href: "mailto:khojadistributions@gmail.com",   sub: "We typically respond within one business day",         Icon: LuMail   },
  { label: "Service Area", value: "DFW Metroplex & Beyond",        href: null,                                     sub: "Serving Dallas, Fort Worth, and towns across Texas",   Icon: LuMapPin },
];

export default function ContactUs() {
  return (
    <div className="min-h-screen bg-brand-surface font-sans">
      <Helmet>
        <title>Contact Khoja Distributions | DFW Wholesale Supplier</title>
        <meta name="description" content="Contact Khoja Distributions at (214) 635-6340 or khojadistributions@gmail.com for wholesale inquiries, delivery questions, and account support across DFW and Texas." />
        <link rel="canonical" href="https://www.khojadistributions.com/contact" />
      </Helmet>

      {/* Hero */}
      <div className="bg-brand-navy py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block bg-brand-amber/20 border border-brand-amber/30 text-brand-amber text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-6">
            Get In Touch
          </span>
          <h1 className="text-4xl md:text-5xl font-black text-white leading-tight tracking-tight mb-6">
            We're Here to Help
          </h1>
          <p className="text-slate-400 text-lg leading-relaxed max-w-xl mx-auto">
            Have a question about an order, want to open a wholesale account, or need to know if we deliver to your area? Reach out — we'd love to hear from you.
          </p>
        </div>
      </div>

      {/* Contact cards */}
      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {contactDetails.map((c, i) => (
            <ScrollReveal key={c.label} delay={i * 0.1}>
              <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm text-center h-full">
                <div className="w-12 h-12 rounded-2xl bg-brand-navy flex items-center justify-center mx-auto mb-4">
                  <c.Icon size={20} className="text-brand-amber" />
                </div>
                <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">{c.label}</p>
                {c.href ? (
                  <a href={c.href} className="text-base font-black text-brand-navy hover:text-brand-amber transition-colors block mb-1">
                    {c.value}
                  </a>
                ) : (
                  <p className="text-base font-black text-brand-navy mb-1">{c.value}</p>
                )}
                <p className="text-xs text-slate-400">{c.sub}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Quick links */}
        <ScrollReveal delay={0.1}>
          <div className="bg-slate-100 rounded-2xl p-8">
            <h2 className="text-lg font-black text-brand-navy mb-2">Looking for something specific?</h2>
            <p className="text-sm text-slate-500 mb-6">These links might get you there faster.</p>
            <div className="flex flex-wrap gap-3">
              <Link to="/register" className="bg-brand-navy hover:bg-brand-amber transition-colors text-white font-bold px-5 py-2.5 rounded-xl text-sm">
                Apply for Wholesale Access
              </Link>
              <Link to="/support" className="border border-slate-200 bg-white text-brand-navy hover:bg-slate-50 font-bold px-5 py-2.5 rounded-xl text-sm transition-colors">
                Submit a Support Request
              </Link>
              <Link to="/products/disposable-vapes" className="border border-slate-200 bg-white text-brand-navy hover:bg-slate-50 font-bold px-5 py-2.5 rounded-xl text-sm transition-colors">
                Browse Products
              </Link>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
}
